import { Fragment } from "react";

import { Button } from "../../../../../../../components/ui";

const SectionHeader = props => {
  const { title, actions } = props;
  return (
    <>
      <div className="flex w-full flex-col gap-4 p-4 font-bold sm:flex-row sm:p-5 sm:pl-8 sm:pr-8 lg:gap-0">
        <div className="flex-1 text-xl sm:text-2xl">{title}</div>
        <div className="flex flex-wrap gap-2 sm:gap-4">
          {actions?.map((item, key) => {
            return item?.component ? (
              <Fragment key={key}>{item?.component()}</Fragment>
            ) : (
              <Button
                action={item.type}
                key={key}
                className={`mr-4 ${item.className}`}
                label={item.label}
                onClick={item.action}
              />
            );
          })}
        </div>
      </div>
      <hr />
    </>
  );
};

export default SectionHeader;
